<!-- FÓKUSZ téma: sötét sáv a modul ikonjával, fülek, ügyfél + év, profil (a NAPLO/BÉR fejlécének párja). -->
<ion-header class="e-fej" *ngIf="fokusz; else klasszikusFej">
  <div class="e-sav">
    <ion-menu-button class="e-hamb csak-mobil" title="Profil, intézmény- és modulváltás"></ion-menu-button>
    <button class="e-marka" type="button" (click)="open('/eszkoz/eszkozok')" title="Tárgyi eszközök">
      <img class="e-logo" [src]="modIkon" alt="">
      <span class="e-marka-szoveg">{{ alrendszerNev }}</span>
    </button>
    <nav class="e-fulek">
      <button *ngFor="let f of fulek" type="button" [class.aktiv]="aktivUt === f.ut" (click)="open(f.ut)">
        <ion-icon [name]="f.ikon"></ion-icon><span>{{ f.cim }}</span>
      </button>
    </nav>
    <div class="e-ter"></div>
    <button class="e-ugyfel" type="button" (click)="valasztoNyit()" title="Ügyfél választása">
      <span class="e-mod" *ngIf="aktiv.ugyfelId">{{ aktiv.konyveles_mod === 'kettos' ? 'KETTŐS' : 'NYILV.' }}</span>
      <span class="e-ugyfel-nev">{{ aktiv.ugyfelNev || 'Válassz ügyfelet' }}</span>
      <ion-icon name="swap-horizontal-outline"></ion-icon>
    </button>
    <select class="e-ev" [ngModel]="aktiv.ev" (ngModelChange)="evValt($event)" title="Év">
      <option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option>
    </select>
    <app-profil-menu class="csak-asztal"></app-profil-menu>
  </div>
</ion-header>

<!-- KLASSZIKUS téma: eszköztár (a menüt a bal sáv adja). -->
<ng-template #klasszikusFej>
  <ion-header [translucent]="true">
    <ion-toolbar class="eszkoz-toolbar">
      <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
      <ion-title>
        <span class="e-cim"><img class="e-ikon" [src]="modIkon" alt=""> {{ alrendszerNev }}</span>
      </ion-title>
      <ion-buttons slot="end">
        <ion-chip class="e-chip" outline (click)="valasztoNyit()">
          <ion-icon name="business"></ion-icon>
          <ion-label>{{ aktiv.ugyfelNev || 'Nincs kiválasztott ügyfél' }}</ion-label>
        </ion-chip>
        <select class="e-ev klasszikus" [ngModel]="aktiv.ev" (ngModelChange)="evValt($event)">
          <option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option>
        </select>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
</ng-template>

<ion-content class="e-tartalom">
  <router-outlet></router-outlet>
</ion-content>

<!-- Ügyfélválasztó: a Könyvelés (NAPLO) ügyféltörzse -->
<ion-modal [isOpen]="valasztoNyitva" (didDismiss)="valasztoNyitva = false" cssClass="bevsor-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Ügyfél választása</ion-title></ion-toolbar></ion-header>
    <div class="bv-torzs e-valaszto">
      <div class="n-szuro-sor">
        <input type="search" [(ngModel)]="kereso" placeholder="Keresés névre, adószámra…" autofocus
               (keydown.enter)="lathatoUgyfelek.length && ugyfelValaszt(lathatoUgyfelek[0])">
        <span class="spacer"></span><span class="halvany">{{ lathatoUgyfelek.length }} ügyfél</span>
      </div>
      <div class="tabla-wrap">
        <table class="n-racs">
          <thead><tr><th>Ügyfél</th><th>Adószám</th><th>Könyvelés</th><th class="num">Eszköz</th></tr></thead>
          <tbody>
            <tr *ngFor="let u of lathatoUgyfelek" class="kattinthato" [class.aktiv]="u.id === aktiv.ugyfelId" [class.inaktiv]="u.inaktiv" (click)="ugyfelValaszt(u)">
              <td><b>{{ u.nev }}</b></td><td>{{ u.adoszam }}</td>
              <td>{{ u.konyveles_mod === 'kettos' ? 'kettős' : 'egyszeres' }}</td>
              <td class="num">{{ u.eszkoz_db || '' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="ures" *ngIf="!lathatoUgyfelek.length">Nincs ügyfél – a Könyvelés (NAPLO) Ügyfelek képernyőjén vehető fel.</div>
      </div>
      <div class="sa-lab" style="padding:10px 14px"><span class="spacer"></span>
        <button type="button" class="ov-gomb" (click)="valasztoNyitva = false">Bezár</button></div>
    </div>
  </ng-template>
</ion-modal>
